import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { defineMessage, useIntl } from 'react-intl';
import { composeCreateFormSchema, ComposeCreateFormValues } from './compose-create-form.schema';
import { useComposeCreateComposition } from './useComposeCreateComposition';
import { Station } from '@app/core/types/stations';

const composeCreatePageFieldNameMessage = defineMessage({
  id: 'compose.createPage.fieldName',
  defaultMessage: 'Nombre',
});

interface ComposeCreateFormProps {
  station: Station;
}

/**
 * Simple form to create a composition (name + implicit station from the active station context).
 */
export function ComposeCreateForm({ station }: ComposeCreateFormProps) {
  const { $t } = useIntl();
  const { submitCreate } = useComposeCreateComposition(station);

  const listPath = composeRouteGenerator.listForStationSlug(station.slug);

  return (
    <FormContainer<ComposeCreateFormValues>
      defaultValues={{ name: '' }}
      resolver={zodResolver(composeCreateFormSchema)}
      onSuccess={async (values) => {
        await submitCreate(values.name);
      }}
    >
      <Stack spacing={3} useFlexGap sx={{ maxWidth: 480 }}>
        <TextFieldElement
          name="name"
          label={$t(composeCreatePageFieldNameMessage)}
          fullWidth
          required
          autoFocus
        />
        <FormActionsMui cancel={listPath} disableOnSubmit disableSubmitIfInvalid />
      </Stack>
    </FormContainer>
  );
}
